import React, { useContext } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from '../components/errorFallback.js';
import * as index from '../modules/code2/index.js';
import * as index$1 from '../modules/primereact/index.js';
import { eventParser } from './eventParser.js';
import { propChecker } from './propChecker.js';
import { PageIdContext } from '../components/pageIdContext.js';
import { DATA_TEST_KEYS } from '../constants.js';

const componentCreator = (component, helpers) => {
    const { templates, newChildren, variables } = helpers;
    const pageId = useContext(PageIdContext);
    const events = eventParser(component.events, variables, component, pageId);
    const comp = packageResolver(component);
    const dataTestProps = {
        [DATA_TEST_KEYS.TYPE]: component.type,
        [DATA_TEST_KEYS.NAME]: component.name,
        [DATA_TEST_KEYS.ID]: component.id
    };
    const props = Object.assign(Object.assign(Object.assign(Object.assign({}, propChecker(component.props, variables, component, templates)), events), dataTestProps), { id: `cmp-${component.id}` });
    const children = (Array.isArray(newChildren) && newChildren.length > 0) ||
        (typeof newChildren === "object" &&
            typeof newChildren.$$typeof === "symbol")
        ? newChildren
        : null;
    return nodeCreator({ component: comp, props, children }, component.ignoreError);
};
const packageResolver = (componentDef) => {
    let component;
    switch (componentDef.package) {
        case "default":
            component = componentDef.type;
            break;
        default:
            let pack = getPackage(componentDef.package);
            component = pack[componentDef.type];
            break;
    }
    return component;
};
const nodeCreator = (node, ignoreError) => {
    if (ignoreError) {
        return React.createElement(node.component, node.props, node.children);
    }
    else {
        return React.createElement(ErrorBoundary, { FallbackComponent: ErrorFallback, onReset: () => { } }, React.createElement(node.component, node.props, node.children));
    }
};
const getPackage = (packageName) => {
    switch (packageName) {
        case "primereact":
            return index$1;
        case "code2":
            return index;
        default:
            return {};
    }
};

export { componentCreator };
//# sourceMappingURL=childrenManager.js.map
